import styled from 'styled-components';
import React, { ReactElement } from 'react';
import { Toolbar } from '../Toolbar';

const transitionMatchingMuiDrawerTransition = 'cubic-bezier(0, 0, 0.2, 1)';

export const Panel = styled.div<{ $open: boolean }>`
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  height: ${({ $open }) => ($open ? '50%' : '0')};
  overflow: hidden;
  pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};
  visibility: ${({ $open }) => ($open ? 'visible' : 'hidden')};
  box-shadow: 0 -4px 13px ${({ theme }) => theme.colors.blue24};
  transition: height
      ${({ theme }) => theme.constants.subnavTransitionDuration}ms
      ${transitionMatchingMuiDrawerTransition},
    visibility 0s
      ${({ $open, theme }) =>
        $open ? '0s' : `${theme.constants.subnavTransitionDuration}ms`};
`;

export const Body = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

type BottomDrawerProps = Pick<
  React.ComponentProps<typeof Toolbar>,
  'centerActions' | 'leftActions' | 'rightActions'
> & {
  open: boolean;
  children: React.ReactNode;
};

export function BottomDrawer({
  open,
  leftActions,
  centerActions,
  rightActions,
  children,
}: BottomDrawerProps): ReactElement {
  return (
    <Panel $open={open} aria-hidden={!open}>
      {(leftActions || centerActions || rightActions) && (
        <Toolbar
          variant="bottomBorder"
          leftActions={leftActions}
          centerActions={centerActions}
          rightActions={rightActions}
        />
      )}
      <Body>{children}</Body>
    </Panel>
  );
}
